const initHighlightTextBanner = () => {
    const highlightTextBanners = document.querySelectorAll('.HighlightBanner--split');

    highlightTextBanners.forEach((banner) => {
        //const text = banner.querySelector('.HighlightBanner--split');
        const text = banner;
        const split = new SplitText(text, SplitText.MODES.LINE);

        let masks = [];

        let lines = split.segments;
        lines.forEach(registerLine);

        const debouncedResize = debounce(onResize, 110);
        window.addEventListener('resize', debouncedResize);

        function onResize(){
            console.log("resize");
            masks = [];
            lines = split.segments;
            lines.forEach(registerLine);
        }

        const scrollTimeline = new ScrollTimeline(banner, animate);

        function animate(ratio) {
            const virtualRatio = easeOutSine(Math.min(1, ratio / 0.8));

            lines.forEach((line, index) => {
                const mask = masks[index];
                const lineRatio = getLineRatio(index, virtualRatio);
                mask.style.clipPath = `inset(0px ${100 - (lineRatio * 100)}% 0px 0px)`;
            });
        }

        function registerLine(line){
            const mask = document.createElement('span');
            mask.textContent = line.textContent;
            mask.classList.add('HighlightBanner--mask');
            line.classList.add('HighlightBanner--line');
            line.appendChild(mask);
            masks.push(mask);
        }

        function getLineRatio(index, ratio){
            const step = 1 / lines.length * 0.9;
            const start = 0.1 + (step * index);
            const end = start + step;

            // get ratio inside the range of start and end
            const lineRatio = (ratio - start) / step;
            return Math.max(0, Math.min(1, lineRatio));
        }
    });
}
initHighlightTextBanner();